import { createSelector } from 'reselect'

const qsSelector = state => state.qs

const qsSearchQuerySelector = createSelector(
	[qsSelector],
	qsSelectorData => qsSelectorData.q || ''
)

export default qsSearchQuerySelector
